var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUserManFilled(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "100%",
    height: "100%",
    viewBox: "0 0 24.347 24.343",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u7EC4_522",
    "data-name": "\\u7EC4 522",
    transform: "translate(-139.755 -3460.86)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_250",
    "data-name": "\\u8DEF\\u5F84 250",
    d: "M151.218,3460.86h1.426c.322.038.643.071.964.116a12.178,12.178,0,0,1,10.307,9.96c.079.457.125.92.187,1.381v1.426a1.8,1.8,0,0,0-.042.228,11.581,11.581,0,0,1-.677,3.193,12.174,12.174,0,0,1-23.408-6.417,12.181,12.181,0,0,1,9.859-9.7C150.292,3460.968,150.757,3460.921,151.218,3460.86Zm.216,13.792c-.288.034-.579.049-.862.1a8.521,8.521,0,0,0-6.556,5.2.33.33,0,0,0,.086.429,10.757,10.757,0,0,0,15.689-.031.3.3,0,0,0,.067-.372,8.537,8.537,0,0,0-1.12-1.951,8.422,8.422,0,0,0-5.071-3.192c-.407-.085-.822-.132-1.261-.2a4.2,4.2,0,1,0-.972.018Z",
    fill: "currentColor"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserManFilled);
export default __webpack_public_path__ + "static/media/user_man_filled.1cda8768.svg";
export { ForwardRef as ReactComponent };